<ng-container *ngIf="results$ | async as results">
  <div class="products-page">
    <div class="page-header-row">
      <h1 class="ss-page-title">Products</h1>
    </div>

    <form class="ss-filter-bar products-filter-bar" [formGroup]="filterForm" (ngSubmit)="search()">
      <input
        class="ss-input filter-input"
        type="text"
        placeholder="Drug name…"
        formControlName="drugName"
      />
      <input
        class="ss-input filter-input"
        type="text"
        placeholder="Manufacturer…"
        formControlName="manufacturer"
      />

      <div class="filter-group catalog-filters">
        <span class="filter-label">Catalog</span>
        <label class="catalog-checkbox">
          <input type="checkbox" formControlName="catalogUk" />
          UK
        </label>
        <label class="catalog-checkbox">
          <input type="checkbox" formControlName="catalogIrish" />
          Irish
        </label>
      </div>

      <button class="ss-btn ss-btn-primary" type="submit">Search</button>
    </form>

    <div class="ss-loading" *ngIf="results.loading">
      <div class="ss-spinner"></div> Loading…
    </div>

    <p class="range-caption" *ngIf="!results.loading && results.hasSearched && results.totalRecords > 0">
      Showing {{ results | pageRange }} of {{ results.totalRecords }}
    </p>

    <p class="error-message" *ngIf="results.errorMessage">{{ results.errorMessage }}</p>

    <div class="products-table-wrap" *ngIf="!results.loading && results.products.length > 0">
      <table class="ss-table">
        <thead>
          <tr>
            <th>Product</th>
            <th>Barcode</th>
            <th>Pack size</th>
            <th>Dosage form</th>
            <th>Active substances</th>
            <th>Catalog</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let product of results.products">
            <td>{{ product.product_name }}</td>
            <td style="color:var(--color-text-muted);font-size:12px">{{ product.barcodes | joinOrDash }}</td>
            <td style="color:var(--color-text-muted)">{{ product.pack_size || '—' }}</td>
            <td style="color:var(--color-text-muted)">{{ product.dosage_form || '—' }}</td>
            <td style="color:var(--color-text-muted);font-size:12px">{{ product | formatSubstances }}</td>
            <td>
              <span class="catalog-badge" [ngClass]="product.catalogSource | catalogClass">
                {{ product.catalogSource | catalogLabel }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="ss-empty" *ngIf="!results.loading && results.hasSearched && results.products.length === 0">
      No products found.
    </div>

    <div class="pagination-bar" *ngIf="results.totalPages > 1 && !results.loading">
      <button
        class="ss-btn ss-btn-secondary ss-btn-sm"
        type="button"
        (click)="previousPage(results)"
        [disabled]="results.pageNumber === 1"
      >
        Previous
      </button>
      <button
        *ngFor="let page of results | visiblePages"
        class="ss-btn ss-btn-secondary ss-btn-sm"
        type="button"
        [style.background]="page === results.pageNumber ? 'var(--color-accent)' : ''"
        [style.color]="page === results.pageNumber ? 'white' : ''"
        (click)="goToPage(page)"
      >
        {{ page }}
      </button>
      <button
        class="ss-btn ss-btn-secondary ss-btn-sm"
        type="button"
        (click)="nextPage(results)"
        [disabled]="results.pageNumber >= results.totalPages"
      >
        Next
      </button>
    </div>
  </div>
</ng-container>
